<template>
  <figure class="c-media-image" v-if="imgSrc && fileId" :id="`elem-${_uid}`">
    <img src="/assets/placeholder.png" :data-src="imgSrc" :alt="compImgAlt">

    <figcaption v-if="caption" class="c-media-image__caption">{{caption}}</figcaption>
  </figure>
</template>

<script>
import filesApi from "@/api/files";
require("intersection-observer");

export default {
  name: "media-image",

  props: ["caption", "fileId", "imgAlt"],

  data() {
    return {
      imgSrc: null,
      loading: true,
      fileName: null
    };
  },

  created() {
    this.getFile(this.fileId);
  },

  beforeUpdate() {
    this.getFile(this.fileId);
  },

  beforeDestroy() {
    this.fileId = null;
  },

  updated() {
    var observer;

    var options = {
      root: null,
      rootMargin: "0px",
      threshold: 0
    };

    if (document.querySelector(`#elem-${this._uid} img`)) {
      observer = new IntersectionObserver(this.ioCallback, options);
      observer.observe(document.querySelector(`#elem-${this._uid} img`));
    }
  },

  methods: {
    ioCallback(entries, observer) {
      const entryToCheck = entries[0];
      if (entryToCheck.isIntersecting && entryToCheck.target.dataset.src) {
        entryToCheck.target.src = entryToCheck.target.dataset.src;
        delete entryToCheck.target.dataset.src;
      }
    },
    getFile(fileId = null) {
      const vm = this;
      setTimeout(function() {
        filesApi.read(fileId).then(file => {
          vm.fileName = file.name;
          filesApi.readLink(file.link).then(response => {
            vm.setFileData(response.data);
          });
        });
      }, 5);
    },

    setFileData(blob) {
      const vm = this;
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = function() {
        const base64data = reader.result;
        vm.imgSrc = base64data;
        vm.loading = false;
      };
    }
  },
  computed: {
    compImgAlt() {
      if (this.imgAlt) {
        return this.imgAlt
      }

      if (this.caption) {
        return this.caption
      }

      return this.fileName;
    }
  },
};
</script>

<style lang="scss">
.c-media-image {
  margin: 1em 0;
  img {
    width: 100%;
    max-width: 100%;
    height: auto;
  }

  &__caption {
    background: $colour-nhs-pale-grey;
    padding: 1em;
    color: #202020;
    font-size: 16px;
  }

  &__loading {
    padding: 4em 0;
  }
}
</style>
